import { render } from "./ProductDeleteDialog.vue?vue&type=template&id=6b34b57e"
import script from "./ProductDeleteDialog.vue?vue&type=script&lang=js"
export * from "./ProductDeleteDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__